import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AccountService } from '@app/_services/account.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-pdf-viewer-dialog',
  templateUrl: './pdf-viewer-dialog.component.html',
  styleUrls: ['./pdf-viewer-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner, NgxExtendedPdfViewerModule, AsyncPipe, TranslatePipe],
})
export class PdfViewerDialogComponent implements OnInit {
  private readonly modalRef = inject(BsModalRef);
  private readonly accountService = inject(AccountService);

  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.loadingSubject.asObservable();

  title!: string;
  pdfSrc!: string;
  bearerToken?: string;
  localeId: string;

  constructor() {
    const translateService = inject(TranslateService);

    // Fixes problem with print orientation.
    pdfDefaultOptions.enablePrintAutoRotate = false;
    this.localeId = translateService.getCurrentLang();
  }

  ngOnInit(): void {
    this.loadingSubject.next(true);
  }

  static showDialog(
    modalService: BsModalService,
    title: string,
    pdfSrc: string,
    bearerToken: string | undefined = undefined,
  ): BsModalRef<PdfViewerDialogComponent> {
    const modalRef = modalService.show(PdfViewerDialogComponent, {
      class: 'modal-lg',
      ignoreBackdropClick: true,
      initialState: {
        title: title,
        pdfSrc: pdfSrc,
        bearerToken: 'Bearer ' + bearerToken,
      },
    });

    return modalRef;
  }

  onClose(): void {
    this.modalRef.hide();
  }

  pdfLoaded(): void {
    this.loadingSubject.next(false);
  }

  pdfLoadingFailed(event: Error | { status?: number }): void {
    if ('status' in event && event?.status === 401) {
      this.accountService.logout();
    }
    this.loadingSubject.next(false);
  }
}
